// apiAxios.js
import axios from "axios";

const apiAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_BASEURL,
  headers: {
    Accept: "application/json",
  },
});

export default apiAxios;
